import { cn } from "../lib/cn";

export interface FormFieldProps {
  label: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}

export function FormField({
  label,
  htmlFor,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={cn("mb-4", className)}>
      <label
        htmlFor={htmlFor}
        className="text-text-dim mb-1 block font-mono text-xs uppercase tracking-wider"
      >
        {label}
      </label>
      {children}
    </div>
  );
}
